<template>
  <div id="app">
    <div class="app-container">
      <!-- Sidebar -->
      <aside class="sidebar">
        <div class="sidebar-header">
          <!-- Replace with your logo path -->
          <img src="/graphGPT/LogoKM.png" alt="Logo" class="logo" />
          <h1 style="font-family: Merriweather;margin-top: -5px;">asK-Y</h1>
        </div>
        <nav class="nav-links">
          <router-link to="/" class="nav-link" exact>Home</router-link>
          <router-link to="/questions" class="nav-link">Questions</router-link>
          <router-link to="/dashboard" class="nav-link">Dashboard</router-link>
          <!-- <router-link to="/" class="nav-link">LogOut</router-link> -->
        </nav>
      </aside>

      <!-- Main Content -->
      <main class="main-content">
        <router-view></router-view>
      </main>
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style scoped>
/* Container for sidebar and main content */
.app-container {
  display: flex;
  min-height: 90vh;
  margin-top: 2rem;
  margin-bottom: 2rem;
}

/* Sidebar styling */
.sidebar {
  /* width: 250px; */
  
  background: #2c3e50;
  color: #ecf0f1;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.sidebar-header {
  text-align: center;
  margin-bottom: 2rem;
}

.logo {
  width: 50px;
  height: 50px;
  margin-bottom: 0.5rem;
}

/* Navigation links */
.nav-links {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.nav-link {
  color: #ecf0f1;
  text-decoration: none;
  padding: 0.75rem 1rem;
  border-radius: 4px;
  margin-bottom: 0.5rem;
  transition: background 0.3s;
  font-family: Merriweather;
}

.nav-link:hover {
  background: #34495e;
}

/* Active link styling (provided by router-link-active) */
.router-link-active {
  background: #34495e;
}

/* Main content area styling */
.main-content {
  flex: 1;
  padding: 2rem;
  background: #f5f7fa;
}
</style>

<!-- 


<template>
    <div id="app">
        <router-view></router-view>
    </div>
  </template>
  
  <script>
  export default {
    name: "App",
  };
  </script>
   -->